import Vue from 'vue';
import Vuex from 'vuex';

import app from 'common/store/module/app';
import detail from 'common/store/module/detail';
import subject from 'common/store/module/subject';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        app,
        detail,
        subject
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/common/store/index.js